import { Command, HttpMethod } from "~/extensions/api";
export class ValidateCodePasswordReissue extends Command {
    constructor(mailaddress, authCode) {
        super(HttpMethod.Post, "auth/password/validate");
        this.mailAddress = mailaddress;
        this.authCode = authCode;
    }
    mailAddress = "";
    authCode = "";
}
